import { render, staticRenderFns } from "./PriceListItemTable.vue?vue&type=template&id=88deaffc&"
import script from "./PriceListItemTable.vue?vue&type=script&lang=js&"
export * from "./PriceListItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports